<template>
  <div>
    <!-- testimonial Section start-->
    <section
      id="testimonial"
      class="testimonial"
    >
      <div class="testimonial-decor">
        <div class="testi-circle1">
          <img
            src="../assets/images/Testimonial2.png"
            alt=""
          >
        </div>
        <div class="testi-circle2">
          <img
            src="../assets/images/Testimonial1.png"
            alt=""
          >
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-10 offset-lg-1">
            <carousel
              class-name="testimonial-carousel "
              :loop="true"
              :margin="30"
              :items="1"
              :center="true"
              :nav="true"
              :dots="false"
              :dots-each="false"
              :autoplay="false"
              :responsive="{0:{items:1,dots:true,nav:false},768:{items:1,dots:true,nav:false},992:{nav:true}}"
            >
              <div class="testimonial-item">
                <div class="testimonial-block">
                  <div class="testimonial-avtar">
                    <img
                      src="../assets/images/avtar/22.jpg"
                      alt=""
                    >
                  </div>
                  <div class="testimonial-text">
                    <p>I would like to thank the MechaniClick team, I needed an extensive and immediate repair for my car and couldn't pay the expense all at once, MechaniClick made it all easy for me. Thanks guys!</p>
                    <h3>Josh McMorris</h3>
                    <!-- <h6>designer</h6>-->
                  </div>
                </div>
              </div>
              <div class="testimonial-item">
                <div class="testimonial-block">
                  <div class="testimonial-avtar">
                    <img
                      src="../assets/images/avtar/1.jpg"
                      alt=""
                    >
                  </div>
                  <div class="testimonial-text">
                    <p></p>
                    <h3>Riley Morelly</h3>
                    <h6>I usually fix most of my car issues on my own, this time I had a major engine problem, the guys did a splendid job and I used their payment plan which took no time to apply and get approved.</h6>
                  </div>
                </div>
              </div>
              <!-- <div class="testimonial-item">
                <div class="testimonial-block">
                  <div class="testimonial-avtar">
                    <img
                      src="../assets/images/avtar/22.jpg"
                      alt=""
                    >
                  </div>
                  <div class="testimonial-text">
                    <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
                    <h3>John Shipmen</h3>
                    <h6>Lead Developer</h6>
                  </div>
                </div>
              </div> -->
            </carousel>
          </div>
        </div>
      </div>
    </section>
    <!-- testimonial Section End -->
  </div>
</template>
<script>
export default {
  name: 'Testimonial',
}
</script>



// WEBPACK FOOTER //
// src/components/testimonial.vue